import { metrics } from "gazelle/src/core/analytics/ga-custom-defs";

export const END_LABEL = 'end';

export const name = '$gzPerf';
export default function $gzPerf(
  $rootScope,
  $window,
  $timeout,
  $state
) {
  'ngInject';
  let vm = this;

  // Initialize to current state since we'll likely
  // miss $stateChangeStart on initial load.
  let loadingState = $state.current;
  let navigationStartOffset = 0;

  let service = {
    viewLoadingStart,
    viewLoadingProgress,
    viewLoadingEnd
  };

  activate();

  return service;

  ////////////////////

  function activate() {
    registerStateListener();
  }

  function registerStateListener() {
    $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {
      if (!hasUserTimingsApi()) {
        // Not supported on this browser
        return;
      }

      loadingState = toState;
      if (_.isEmpty(fromState)) {
        navigationStartOffset = 0;
      } else {
        navigationStartOffset = $window.performance.now();
      }
    });
  }

  function viewLoadingStart() {
    if (!hasUserTimingsApi()) {
      // Not supported on this browser
      return;
    }

    $window.performance.mark(`${loadingState.name}-start`);
  }

  function viewLoadingProgress(sublabel) {
    sendViewLoadingEvent(sublabel);
  }

  function viewLoadingEnd() {
    // Execute inside of a timeout to get closer to the actual rendering time since
    // this will be queued after DOM updates.
    // See https://stackoverflow.com/a/22541080/277307
    $timeout(() => {
      sendViewLoadingEvent(END_LABEL);
    }, 0, false);
  }

  function sendViewLoadingEvent(sublabel) {
    if (!hasUserTimingsApi()) {
      // Not supported on this browser
      return;
    }

    let label = loadingState.name;
    const startLabel = `${label}-start`;
    const endLabel = `${label}-${sublabel}`;
    const measureLabel = `${endLabel}-measure`;
    $window.performance.mark(endLabel);

    let startMark = getPerformanceEntry(startLabel, 'mark');
    if (!startMark) {
      return;
    }

    let endMark = getPerformanceEntry(endLabel, 'mark');
    if (!endMark) {
      return;
    }

    $window.performance.measure(measureLabel, startLabel, endLabel);
    let measure = getPerformanceEntry(measureLabel, 'measure');
    if (!measure) {
      return;
    }

    let cachedResources = countCachedResources();

    let eventLabel = label;
    if (sublabel !== END_LABEL) {
      // only report the sublabel for loading progress events
      eventLabel = `${label} - ${sublabel}`;
    }

    let hit = {
      hitType: 'event',
      nonInteraction: true,
      eventCategory: 'performance',
      eventAction: 'view loading',
      eventLabel,
      eventValue: $window.Math.round(measure.duration),
      [metrics.startDuration]: $window.Math.round(startMark.startTime - navigationStartOffset),
      [metrics.endDuration]: $window.Math.round(endMark.startTime - navigationStartOffset),
      [metrics.cachedResources]: cachedResources,
    };
    $window.ga('send', hit);

    if (sublabel === END_LABEL) {
      $window.performance.clearMarks(startLabel);
    }
    $window.performance.clearMarks(endLabel);
    $window.performance.clearMeasures(measureLabel);
  }

  function countCachedResources() {
    let resourceTimings = $window.performance.getEntriesByType('resource');
    return resourceTimings.reduce((accumulator, resourceTiming) => {
      // Must check for requestStart because CORS Timing-Allow-Origin header is not on external resources.
      if (resourceTiming.requestStart && !resourceTiming.transferSize) {
        accumulator++;
      }
      return accumulator;
    }, 0);
  }

  function hasUserTimingsApi() {
    return _.get($window, 'performance.mark');
  }

  function getPerformanceEntry(name, type) {
    let entries = $window.performance.getEntriesByName(name, type);
    if (entries.length !== 1) {
      $window.ga('send', {
        hitType: 'exception',
        exDescription: `$gzPerf: unexpected number of performance entries for ${name}. Expected 1, found ${entries.length}`,
        exFatal: false,
      });
      return undefined;
    }
    return entries[0];
  }
}
